module.exports = __webpack_public_path__ + "img/buscador.2ef52227.png";